import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { Dayjs } from "dayjs";
import { Dispatch, ReactNode, SetStateAction } from "react";

interface DateSelectorProps {
  value: Dayjs;
  setValue: Dispatch<SetStateAction<Dayjs>>;
  label: string;
  disablePast?: boolean;
  minDate?: Dayjs;
  size?: "small" | "medium";
  helperText?: string;
}

export const LocalizationProviderContainer = ({
  children,
}: {
  children: ReactNode;
}) => (
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
    {children}
  </LocalizationProvider>
);

const DateSelector = (props: DateSelectorProps) => {
  const { value, setValue, label, disablePast, minDate, size, helperText } =
    props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DatePicker
        label={label}
        slotProps={{
          textField: {
            size: size ?? "small",
            sx: {
              width: "100%",
            },
            helperText: helperText,
          },
        }}
        value={value}
        onChange={(e) => setValue(e)}
        dayOfWeekFormatter={(day: string) => day}
        disablePast={disablePast}
        minDate={minDate}
      />
    </LocalizationProvider>
  );
};

export default DateSelector;
